import { useMelioIntl } from '@melio/ar-domain';
import { Form, GridItem, NakedButton } from '@melio/penny';
import { forwardRef, useBoolean } from '@melio/platform-utils';
import React from 'react';

import { FormSection, useInvoiceFormContext } from '../../../utils';
import { PayOptionCard } from './PayOptionCard';

export const PayOptionsFormSection = forwardRef(({ ...props }, ref) => {
  const { registerField } = useInvoiceFormContext();
  const { formatMessage } = useMelioIntl();
  const [isCustomExpanded, expandCustom] = useBoolean(false);

  return (
    <FormSection
      title={formatMessage('ar.invoiceLifecycle.activities.createInvoice.form.sections.payOptions.label')}
      colSpan={[1, 1, 2]}
      columns={[1, 1, 2]}
      data-component={PayOptionsFormSection.displayName}
      data-testid="form-section-payment-options"
      {...props}
      ref={ref}
    >
      <GridItem>
        <PayOptionCard payOptionType="bankTransfer" />
      </GridItem>
      <GridItem>
        <PayOptionCard payOptionType="card" />
      </GridItem>
      {!isCustomExpanded && (
        <GridItem colSpan={[1, 1, 2]}>
          <NakedButton
            data-testid="add-custom-instructions-button"
            onClick={() => expandCustom.toggle()}
            label={formatMessage('ar.invoiceLifecycle.activities.createInvoice.inputs.payOptions.options.custom.add')}
            variant="secondary"
          />
        </GridItem>
      )}
      <GridItem colSpan={[1, 1, 2]}>
        <Form.TextArea
          isHidden={!isCustomExpanded}
          {...registerField('customInstructions')}
          labelProps={{
            label: formatMessage('ar.invoiceLifecycle.activities.createInvoice.inputs.payOptions.options.custom.title'),
          }}
          placeholder={formatMessage(
            'ar.invoiceLifecycle.activities.createInvoice.inputs.payOptions.options.custom.description'
          )}
          helperTextProps={{
            label: formatMessage(
              'ar.invoiceLifecycle.activities.createInvoice.inputs.payOptions.options.custom.helperText'
            ),
          }}
          maxChars={300}
        />
      </GridItem>
    </FormSection>
  );
});
PayOptionsFormSection.displayName = 'PayOptionsFormSection';
